@let _isFooterVisible = isFooterVisible();
<div
	#ChatTranscript
	class="ada-chat-transcript {{ _isFooterVisible ? 'ada-no-footer' : '' }}"
>
	@if (showTranscript()) {
		@for (message of messages(); track $index) {
			<ng-container
				[ngComponentOutlet]="registrations | mapValue: message.type"
				[ngComponentOutletInputs]="{
					message,
					menuTemplate: MenuTemplate,
					timestampTemplate: TimestampTemplate,
					isActive: $index === activeIndex(),
				}"
			>
				<ng-template #TimestampTemplate>
					<span
						ada-opacity="60"
						ada-type="small"
					>
						{{ message.timestamp | adaLocalizedDate: 'shortTime' }}
					</span>
				</ng-template>
				<ng-template #MenuTemplate>
					@let _controller = message.source === responseType ? responseController() : queryController();
					@if (_controller) {
						<ada-inline-menu
							[controller]="_controller"
							[data]="message.data"
						/>
					}
				</ng-template>
			</ng-container>
		}
	}

	@if (suggestions()?.length) {
		<div
			ada-suggested-prompts
			[isDisabled]="isDisabled"
			[suggestions]="suggestions()"
			(selected)="messageSent.emit($event)"
		></div>
	}

	@if (isResponding()) {
		<ada-ellipsis
			[dotOpacity]="0.25"
			[dotSizePx]="6"
		/>
	}
</div>
@if (_isFooterVisible) {
	<form class="ada-chat-input ada-border-top">
		<ng-container *ngTemplateOutlet="projectedFooter()" />
		<div
			#ChatInput
			class="ada-chat-fake-input ada-border"
			tabindex="0"
			[attr.chat-placeholder]="inputPlaceholder()"
			[attr.contenteditable]="isChatEditable()"
			[class.ada-is-disabled]="!isSendAllowed()"
			(input)="onInput($event)"
			(keydown)="sendMessageOnEnter($event)"
		></div>
		@if (shouldShowWarning()) {
			<span
				class="ada-type-small ada-font-weight-bold"
				[class.ada-color-error]="isOverLimit()"
				[class.ada-color-warning]="!isOverLimit()"
			>
				{{ inputWarning() }} ({{ messageLength() }} of {{ characterLimit() }})
			</span>
		}
		<button
			ada-color="onPrimary"
			class="ada-btn ada-btn-solid ada-btn-primary ada-chat-send-button"
			[class.ada-is-disabled]="sendDisabled()"
			(click)="!sendDisabled() && sendMessage()"
		>
			<ada-icon icon="faPaperPlane" /> {{ sendButtonText() }}
		</button>
	</form>
}
